<div class="mapa1" #mapRef style="width:100%;height:100%"></div>
<div class="mapa2" #mapRef *ngIf="direcciones?.length > 1" style="width:100%;height:100%"></div>
<div class="mapa3" #mapRef *ngIf="direcciones?.length > 2" style="width:100%;height:100%"></div>
<div class="mapa4" #mapRef *ngIf="direcciones?.length > 3" style="width:100%;height:100%"></div>
<div class="mapa5" #mapRef *ngIf="direcciones?.length > 4" style="width:100%;height:100%"></div>
<div class="mapa6" #mapRef *ngIf="direcciones?.length > 5" style="width:100%;height:100%"></div>